import { configureStore } from '@reduxjs/toolkit';

import { mainPageApi } from './services/mainPageApi';
import { staticPageApi } from './services/staticPageApi';

export const store = configureStore({
    reducer: {
        [mainPageApi.reducerPath]: mainPageApi.reducer,
        [staticPageApi.reducerPath]: staticPageApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(mainPageApi.middleware, staticPageApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
